/**
 * @flow
 * @relayHash 2eee8b599eae45bb05a078f41555ea5c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type TVShowEpisodeState = "available" | "hidden" | "%future added value";
export type TVShowEpisodeEditInput = {
  id: string,
  title: string,
  subtitle: string,
  description: string,
  shortDescription?: ?string,
  video?: ?string,
  videoFile?: ?string,
  preview?: ?string,
  show?: ?string,
  startDate: string,
  endDate: string,
  topics?: ?$ReadOnlyArray<?string>,
  state: TVShowEpisodeState,
  liveShow?: ?boolean,
  clientMutationId?: ?string,
};
export type TVShowEpisodeEditMutationVariables = {|
  input: TVShowEpisodeEditInput
|};
export type TVShowEpisodeEditMutationResponse = {|
  +TVShowEpisodeEdit: ?{|
    +tVShowEpisode: ?{|
      +id: string
    |}
  |}
|};
export type TVShowEpisodeEditMutation = {|
  variables: TVShowEpisodeEditMutationVariables,
  response: TVShowEpisodeEditMutationResponse,
|};
*/


/*
mutation TVShowEpisodeEditMutation(
  $input: TVShowEpisodeEditInput!
) {
  TVShowEpisodeEdit(input: $input) {
    tVShowEpisode {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "TVShowEpisodeEditInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "TVShowEpisodeEdit",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "TVShowEpisodeEditInput!"
      }
    ],
    "concreteType": "TVShowEpisodeEditPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "tVShowEpisode",
        "storageKey": null,
        "args": null,
        "concreteType": "TVShowEpisode",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "TVShowEpisodeEditMutation",
  "id": null,
  "text": "mutation TVShowEpisodeEditMutation(\n  $input: TVShowEpisodeEditInput!\n) {\n  TVShowEpisodeEdit(input: $input) {\n    tVShowEpisode {\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "TVShowEpisodeEditMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "TVShowEpisodeEditMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2933a327bc458b96ccbace4cd89581e9';
module.exports = node;



// WEBPACK FOOTER //
// src/mutations/__generated__/TVShowEpisodeEditMutation.graphql.js